import { StandardEvents } from '@shopify/events';

class MvCollectionFilterDrawer extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    document.addEventListener('click', this.onDocumentClick, options);
    this.addEventListener('change', () => queueMicrotask(() => this.syncCount()), options);
    this.addEventListener('input', (event) => {
      const priceFacet = event.target.closest('price-facet-component');
      if (!priceFacet) return;
      clearTimeout(this.priceTimer);
      this.priceTimer = setTimeout(() => {
        if (priceFacet.isConnected) priceFacet.updatePriceFilterAndResults();
      }, 500);
    }, options);
    this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.close(); }, options);
    this.dialog.addEventListener('click', (event) => {
      if (event.target !== this.dialog) return;
      const rect = this.dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
    }, options);
    this.addEventListener(StandardEvents.collectionUpdate, (event) => {
      const expanded = [...this.querySelectorAll('details[open]')].map(el => el.dataset.mvNativeSection || (el.classList.contains('mv-filter-sort') ? 'sort' : null)).filter(Boolean);
      this.querySelector('[data-mv-filter-apply]').setAttribute('aria-busy', 'true');
      event.promise.then(() => {
        this.querySelectorAll('details').forEach(el => { el.open = expanded.includes(el.dataset.mvNativeSection || (el.classList.contains('mv-filter-sort') ? 'sort' : null)); });
        this.syncCount();
      }).catch(() => { this.querySelector('[data-mv-filter-apply]').textContent = 'RÉESSAYER EN FERMANT LES FILTRES'; })
        .finally(() => this.querySelector('[data-mv-filter-apply]').removeAttribute('aria-busy'));
    }, options);
    queueMicrotask(() => this.syncCount());
  }
  disconnectedCallback() { clearTimeout(this.priceTimer); this.controller?.abort(); if (this.dialog?.open) this.close(); }
  onDocumentClick = (event) => {
    const trigger = event.target.closest('[data-mv-filter-open]');
    if (trigger?.getAttribute('aria-controls') === this.dialog.id) {
      this.trigger = trigger;
      this.oldOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
      trigger.setAttribute('aria-expanded', 'true');
      this.querySelector('.mv-filter-close').focus();
      this.syncCount();
    }
    if (!this.contains(event.target)) return;
    if (event.target.closest('[data-mv-filter-close]')) this.close();
    if (event.target.closest('[data-mv-filter-reset]')) this.reset();
  };
  close() {
    this.dialog.close();
    document.documentElement.style.overflow = this.oldOverflow || '';
    const trigger = document.querySelector(`[aria-controls="${this.dialog.id}"]`);
    trigger?.setAttribute('aria-expanded', 'false');
    trigger?.focus();
  }
  syncCount() {
    const status = this.closest('.shopify-section')?.querySelector('.mv-filter-toolbar [role="status"]');
    if (!status) return;
    const count = Number(status.textContent.replace(/[^0-9]/g, ''));
    this.querySelector('[data-mv-filter-apply]').textContent = `AFFICHER ${count === 1 ? 'LE' : 'LES'} ${count} RÉSULTAT${count === 1 ? '' : 'S'}`;
  }
  reset() {
    const form = this.querySelector('facets-form-component');
    const url = new URL(location.href);
    url.search = '';
    form.updateFiltersByURL(url);
  }
}
if (!customElements.get('mv-collection-filter-drawer')) customElements.define('mv-collection-filter-drawer', MvCollectionFilterDrawer);
